import { decodeText } from '../../../utils/decodeText.js';
import { UTF_8 } from '../../../utils/UTF_8.js';
export function readUtf8String(dataView, offset) {
    const length = dataView.byteLength - (offset - dataView.byteOffset);
    return (length > 0) ? decodeText(new DataView(dataView.buffer, offset, length), { encoding: UTF_8 }) : '';
}
;
//# sourceMappingURL=readUtf8String.js.map